// extracted by mini-css-extract-plugin
module.exports = {"root":"SortRefinementForPackages_root__5ay7G","title":"SortRefinementForPackages_title__l5t_A","select":"SortRefinementForPackages_select__rqNMf"};